import { Component, OnInit } from '@angular/core';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'oir-spinner',
  template: '<div class="spinner" [class.visible]="visible"></div>',
  styleUrls: ['./spinner.component.less']
})
export class SpinnerComponent implements OnInit {
  public visible: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.model.subscribe(visible => {
      this.visible = visible;
    });
  }
}
